import React, { useEffect, useState } from 'react';
import CardHoc from "../Hoc/cardHoc";
import { connect } from 'react-redux';
import * as actionsRedux from '../Store/Actions/index';
import { Button, Col, Modal, ModalBody, Row, Spinner } from 'reactstrap';
import { dateToPtBr } from '../Basicos/funcoes';
import { FiTrash2 } from 'react-icons/fi';
import Select from 'react-select'
import { axiosApi } from '../Basicos/axiosInstances';

function ModalEditarConteudo2({
    isOpen,
    dados,
    setConteudoDisponivel,
    conteudoDisponivel,
    closeModal,
    setDadosModalConteudo,
    dadosModalConteudo,
    ativar
}) {
    const [dadosModalTemp, setDadosModalTemp] = useState([]);
    const [conteudoDisponivelTemp, setConteudoDisponivelTemp] = useState([]);
    const [itensAdicionados, setItensAdicionados] = useState([]);
    const [itensRemovidos, setItensRemovidos] = useState([]);
    const [loading, setLoading] = useState(false);
    const acoes = {
        "criar": true,
        "editar": true,
        "deletar": true
    }

    useEffect(() => {
        if (isOpen) {
            setDadosModalTemp(JSON.parse(JSON.stringify(dados)));
            setConteudoDisponivelTemp(conteudoDisponivel);
            setItensAdicionados([]);
            setItensRemovidos([]);
        }
    }, [isOpen]);

    const removerAula = (index) => {
        const itemRemovido = dadosModalTemp.conteudo[index];

        const novaAula = {
            value: itemRemovido.conteudo_aula_id,
            label: itemRemovido.titulo,
            completo: itemRemovido
        };

        setConteudoDisponivelTemp((prevAulasDisponiveis) => ({
            ...prevAulasDisponiveis,
            [dadosModalTemp?.tipo_atividade_id]: [
                ...(prevAulasDisponiveis?.[dadosModalTemp?.tipo_atividade_id] || []),
                novaAula,
            ],
        }));

        // Se o item removido tinha sido adicionado nesta mesma sessão de edição,
        // ele nunca chegou a ser salvo: basta descartá-lo de "adicionados" em vez
        // de registrá-lo como "removido" (o que tentaria remover algo inexistente).
        if (itensAdicionados.includes(itemRemovido)) {
            setItensAdicionados((prev) => prev.filter((item) => item !== itemRemovido));
        } else {
            setItensRemovidos((prev) => [...prev, itemRemovido]);
        }

        const novoConteudo = dadosModalTemp.conteudo.filter((_, i) => i !== index);
        setDadosModalTemp((prevState) => ({
            ...prevState,
            conteudo: novoConteudo,
        }));
    }

    const { conteudoComDivergencia, conteudosFaltantes } = React.useMemo(() => {
        const conteudoAtual = dadosModalTemp?.conteudo || [];
        const outrasTurmas = dadosModalTemp?.outras_turmas_conteudos || {};

        const obterChave = (c) => {
            const tituloLimpo = String(c.titulo || '').trim().toUpperCase();
            if (c.conteudo_aula_id && !c.servico) {
                return `aula_${tituloLimpo}`;
            }
            return `servico_${tituloLimpo}`;
        };

        const chavesAtuais = conteudoAtual.map(obterChave);

        const mapOutrasTurmas = {};
        const detalhesOutrasTurmas = {};

        Object.entries(outrasTurmas).forEach(([turmaNome, conteudosOutra]) => {
            mapOutrasTurmas[turmaNome] = (conteudosOutra || []).map(c => {
                const key = obterChave(c);
                detalhesOutrasTurmas[key] = c;
                return key;
            });
        });

        const novoConteudo = conteudoAtual.map(item => {
            const key = obterChave(item);
            const turmasSemEste = [];

            Object.entries(mapOutrasTurmas).forEach(([turmaNome, chavesOutra]) => {
                if (!chavesOutra.includes(key)) {
                    turmasSemEste.push(turmaNome);
                }
            });

            return {
                ...item,
                extra: turmasSemEste.length > 0,
                turmas_sem_este_conteudo: turmasSemEste
            };
        });

        const faltantesMap = {};

        Object.entries(mapOutrasTurmas).forEach(([turmaNome, chavesOutra]) => {
            chavesOutra.forEach(key => {
                if (!chavesAtuais.includes(key)) {
                    if (!faltantesMap[key]) {
                        faltantesMap[key] = {
                            detalhes: detalhesOutrasTurmas[key],
                            turmasComEste: []
                        };
                    }
                    if (!faltantesMap[key].turmasComEste.includes(turmaNome)) {
                        faltantesMap[key].turmasComEste.push(turmaNome);
                    }
                }
            });
        });

        const novosFaltantes = Object.values(faltantesMap).map(f => ({
            ...f.detalhes,
            faltando: true,
            turmas_com_este_conteudo: f.turmasComEste
        }));

        return {
            conteudoComDivergencia: novoConteudo,
            conteudosFaltantes: novosFaltantes
        };
    }, [dadosModalTemp?.conteudo, dadosModalTemp?.outras_turmas_conteudos]);

    const close = () => {
        setDadosModalTemp([]);
        setConteudoDisponivelTemp([]);
        closeModal();
    }

    const salvar = async () => {
        try {
            setLoading(true);
            let dado = {
                conteudo_prova_id: dados.conteudo_prova_id,
                prova_id: dados.horario_aula_prova_id,
                semestre_id: dados.semestre_id,
                periodo_letivo_id: dados.periodo_letivo_id,
                turma_id: dados.turma_id,
                adicionados: itensAdicionados,
                removidos: itensRemovidos,
            }

            const response = await axiosApi.put(`semana-padrao/cadastro-de-ofertas/conteudo-prova/${dados.conteudo_prova_id}`, dado);

            const reqData = {
                periodo: dados.periodo_letivo_id,
                semestre: dados.semestre_id,
                turma: dados.turma_id,
                tipo_atividade: null
            };
            const refreshResponse = await axiosApi.post('/gerar-conteudo', reqData);
            let infos = refreshResponse.data.dados;
            infos.extra = reqData;

            setDadosModalConteudo(infos);
            setConteudoDisponivel(refreshResponse.data.disponiveis || conteudoDisponivelTemp);
            ativar(201, 'Conteúdo da prova atualizado com sucesso!')
            closeModal();
        } catch (error) {
            const mensagemErro = error?.response?.data?.erro || 'Algo deu errado.';
            ativar(400, mensagemErro)
        } finally {
            setLoading(false);
        }
    }

    const selecionarAula = (value) => {
        const novoConteudo = value.completo;
        const novoConteudoArray = [...dadosModalTemp.conteudo, novoConteudo];

        novoConteudoArray.sort((a, b) => {
            let dataA = new Date(a.datas[0]);
            let dataB = new Date(b.datas[0]);
            return dataA - dataB;
        });

        setDadosModalTemp((prevState) => ({
            ...prevState,
            conteudo: novoConteudoArray,
        }));

        setConteudoDisponivelTemp((prevAulasDisponiveis) => {
            const novasAulas = prevAulasDisponiveis[dadosModalTemp.tipo_atividade_id]?.filter(
                (aula) => aula.value !== novoConteudo.conteudo_aula_id
            );

            return {
                ...prevAulasDisponiveis,
                [dadosModalTemp.tipo_atividade_id]: novasAulas,
            };
        });

        // Se este item tinha sido removido nesta mesma sessão de edição e agora está
        // sendo adicionado de volta, cancela a remoção em vez de marcá-lo como "adicionado"
        // (ele já existe salvo na prova, não precisa ser reenviado como novo).
        if (itensRemovidos.includes(novoConteudo)) {
            setItensRemovidos((prev) => prev.filter((item) => item !== novoConteudo));
        } else {
            setItensAdicionados((prev) => [...prev, novoConteudo]);
        }
    };

    return (
        <Modal isOpen={isOpen} size={'xl'}>
            <ModalBody className="modal-editar-conteudo">
                <Col sm={12} className="align-content-middle mb-4 mt-2">
                    <h3><b>Conteúdo da Prova {dados.titulo_prova} - {dados.data_prova}</b></h3>
                </Col>
                <Row className="filtro-modal-conteudo">
                    <Select
                        noOptionsMessage={() => 'Sem opções'}
                        defaultValue={[]}
                        value={null}
                        placeholder={"Adicionar Conteúdos"}
                        options={conteudoDisponivelTemp?.[dados.tipo_atividade_id]}
                        onChange={(value) => selecionarAula(value)}
                        className={"select select-form"}
                    />
                </Row>
                {conteudosFaltantes && conteudosFaltantes.length > 0 && (
                    <Row className="mx-0 mt-3 mb-2">
                        <Col sm={12} style={{ 
                            padding: '10px 15px', 
                            backgroundColor: '#fff3cd', 
                            borderLeft: '4px solid #ffc107', 
                            color: '#856404',
                            borderRadius: '4px',
                            fontSize: '0.9rem',
                            display: 'flex',
                            alignItems: 'center',
                            flexWrap: 'wrap'
                        }}>
                            <span style={{ marginRight: '8px' }}>⚠️</span>
                            <strong>Conteúdo(s) ausente(s) nesta turma (presente em outras turmas):</strong>
                            <span style={{ marginLeft: '6px' }}>
                                {conteudosFaltantes.map((c, i) => (
                                    <span 
                                        key={i} 
                                        title={`Presente em: ${c.turmas_com_este_conteudo?.join(', ')}`} 
                                        style={{ textDecoration: 'underline', cursor: 'help', marginRight: '10px', fontWeight: '500' }}
                                    >
                                        {c.titulo}
                                    </span>
                                ))}
                            </span>
                        </Col>
                    </Row>
                )}
                <Row className="mt-2">
                    <Col md={3}>
                        <h5><b>Data</b></h5>
                    </Col>
                    <Col md={4}>
                        <h5><b>Aula</b></h5>
                    </Col>
                    <Col md={3}>
                        <h5><b>Professores</b></h5>
                    </Col>
                    <Col md={2}>
                    </Col>
                </Row>
                {
                    conteudoComDivergencia?.map((conteudo, index) => {
                        return <>
                            <Row className="mt-2 linha-conteudo-prova">
                                <Col md={3} className="coluna-data-modal">
                                    <h6 className="modal-conteudo-edit">{
                                        conteudo?.datas.map((data, index) => {
                                            return <>
                                                {`${conteudo?.datas.length - 1 == index ? dateToPtBr(data) : `${dateToPtBr(data)}, `}`}
                                            </>
                                        })
                                    }</h6>
                                </Col>
                                <Col md={4}>
                                    <h6 className="modal-conteudo-edit">
                                        {conteudo?.titulo}
                                        {conteudo?.extra && (
                                            <span 
                                                title={`Este conteúdo está a mais em relação a: ${conteudo.turmas_sem_este_conteudo?.join(', ')}`}
                                                style={{
                                                    backgroundColor: '#fadbd8',
                                                    color: '#c0392b',
                                                    fontSize: '0.75rem',
                                                    padding: '2px 6px',
                                                    borderRadius: '4px',
                                                    marginLeft: '8px',
                                                    fontWeight: 'bold',
                                                    cursor: 'help'
                                                }}
                                            >
                                                A mais ⚠️
                                            </span>
                                        )}
                                    </h6>
                                </Col>
                                <Col md={3}>
                                    <h6 className="modal-conteudo-edit">{
                                        Array.isArray(conteudo?.professores)
                                            ? conteudo.professores.map((prof, idx) => (
                                                <React.Fragment key={idx}>
                                                    {`${conteudo.professores.length - 1 === idx ? prof : `${prof}, `}`}
                                                </React.Fragment>
                                            ))
                                            : conteudo?.professores
                                    }</h6>
                                </Col>
                                <Col md={1}>
                                    <FiTrash2 onClick={() => removerAula(index)} size={"25px"} className="icon-remover-list menuIcons" style={{ cursor: "pointer" }} />
                                </Col>
                            </Row>
                        </>
                    })
                }

                <Row>
                    <Col className="align-content-middle mt-4">
                        <Button className="mx-3" onClick={() => close()} disabled={loading}>Cancelar</Button>
                        <Button className="mx-3" onClick={() => salvar()} disabled={loading}>
                            {loading ? (
                                <>
                                    <Spinner size="sm" color="light" style={{ marginRight: '8px' }} />
                                    Salvando...
                                </>
                            ) : (
                                'Salvar'
                            )}
                        </Button>
                    </Col>
                </Row>
            </ModalBody>
        </Modal>
    );
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        ativar: (tipo, acao) => dispatch(actionsRedux.ativarAlert(tipo, acao)),
        ativarCofirmacao: (obj) => dispatch(actionsRedux.ativarModalConfirm(obj)),
        atualizarDadosRemotamente: () => dispatch(actionsRedux.atualizarSubFuncionalidade(ownProps.funcionalidade, ownProps.indiceSubFuncionalidade)),
    }
}

export default connect(null, mapDispatchToProps)(CardHoc(ModalEditarConteudo2));